import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Textarea as TextareaWrapper, FormErrorMessage, FormControl } from '@chakra-ui/react';
import { formatDataTestId } from '../../utils/formatters';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var baseDataTestId = 'textarea';
export default function Textarea(props) {
  var isError = (props === null || props === void 0 ? void 0 : props.error) !== undefined;
  return _jsxs(FormControl, _objectSpread(_objectSpread({}, wrapperStyles), {}, {
    isInvalid: isError,
    children: [_jsx(TextareaWrapper, _objectSpread({
      maxLength: props === null || props === void 0 ? void 0 : props.maxLength
    }, props)), (props === null || props === void 0 ? void 0 : props.error) && renderFieldErrorMessage(props)]
  }));
}
function renderFieldErrorMessage(props) {
  return _jsx(FormErrorMessage, _objectSpread(_objectSpread({
    "data-testid": formatDataTestId(baseDataTestId, "".concat(name, "-FormErrorMessage"))
  }, errorMsgStyle), {}, {
    children: props === null || props === void 0 ? void 0 : props.error
  }));
}
var errorMsgStyle = {
  fontSize: 'xs',
  color: 'error',
  ml: 'md',
  mt: 'sm'
};
var wrapperStyles = {
  borderRadius: 'xs',
  zIndex: 0,
  borderColor: 'lightGrey1',
  _hover: {
    borderColor: 'darkGrey1'
  },
  _focus: {
    zIndex: '0'
  },
  sx: {
    textarea: {
      ':focus': {
        borderColor: '#00798e'
      }
    }
  }
};